import { Layout } from '@/shared/Layout/ui';
import * as S from './LandmarkDestinationPage.style';
import { Container } from '@/common/ui/containers/Container';
import { buildRootUrl } from '@/common/app/utils/urlsUtils';
import { CommonMeta } from '@/common/ui/meta/CommonMeta';
import { TLandmarksShort } from '@/screens/LandmarkMainPage/domain/Landmarks.domain';
import { LandmarkCard } from '@/screens/LandmarkMainPage/ui/LandmarkCard';
import { TBreadcrumbItems } from '@/shared/Breadcrumbs/domain/Breadcrumbs.domain';
import { AnswersFAQ } from '@/screens/ActivityPage/ui/Answers/AnswersFAQ';

export type TLandmarksListPageProps = {
    heroImages: string[];
    landmarks: TLandmarksShort;
    breadcrumbs: TBreadcrumbItems;
    destinationName: string;
    destinationId: string;
    destinationSlug: string;
    destinationCode: string;
    destinationStateName: string;
};

export const LandmarksListPageContainer = ({
    heroImages,
    landmarks,
    breadcrumbs,
    destinationName,
    destinationId,
    destinationSlug,
    destinationCode,
    destinationStateName,
}: TLandmarksListPageProps) => {
    const pageTitle = `${destinationName}, ${destinationCode}`;
    const pageDescription = `Landmarks in ${destinationName}, ${destinationStateName}`;
    const pagePath = `/destination/${destinationCode}/${destinationName}/landmarks/`;
    const canonical = buildRootUrl(pagePath);
    const title = `Landmarks ${pageTitle}`;

    return (
        <Layout TitleName={pageTitle} images={heroImages} breadcrumbs={breadcrumbs}>
            <CommonMeta
                title={title}
                description={pageDescription}
                slug={pagePath}
                ogUrl={canonical}
                ogType="website"
                ogTitle={`Tripshock! Landmarks & Guides ${pageTitle}`}
                ogImageAlt={`Tripshock! Landmarks & Guides ${pageTitle}`}
                imageSrc={heroImages[0]}
                canonical={canonical}
            />
            <Container>
                <S.Title data-test-id="Title">{pageDescription}</S.Title>
                <S.CardsGrid>
                    {landmarks.map((item) => (
                        <LandmarkCard
                            item={item}
                            destinationSlug={destinationSlug}
                            stateCode={destinationCode}
                            key={item.slug}
                            isTopSign
                            minWidthFull
                        />
                    ))}
                </S.CardsGrid>
            </Container>
            <AnswersFAQ
                title={title}
                url={canonical}
                image={heroImages[0]}
                id={`landmarks_d${destinationId}`}
            />
        </Layout>
    );
};
